import ap from '@tencent/txv-athena/api';
import { getPlatformId } from '@tencent/txv-athena/helper';
import { roleSelectDialog } from './dialog';
import tips from '@tencent/txv-athena/tips';

/* global globalThis */
const SERVICE = {
  MISSION: '/trpc.iwan.mission_system_server.MissionSystemSvr/',
  TEAM: '/trpc.iwan.team_server.TeamServer/',
  BOOST: '/trpc.game_community.iwan_boost.IwanBoost/',
};

const paramMap = {
  serverId: 'partition',
  partition: 'serverId',
  sArea: 'area',
  area: 'sArea',
  sPlat: 'platid',
  platid: 'sPlat',
  sRoleId: 'charac_no',
  charac_no: 'sRoleId',
  boost_id: 'boost_id',
};

export const COMPONENT_TYPE = {
  GIFT: 1001,
  TASK: 1002,
  TEAM: 1003,
  SIGN: 1004,
  ASSISTANCE: 1005,
  POINT: 1006,
  // 中台版本的签到
  SIGNIN_NEW: 10,
};

// 获取批量礼包
export const getMultiGiftInfo = ({ params }) => ap.get('/api/v6/getMutiGift', {
  unique: true,
  params,
});

// 获取任务信息
export const getTaskInfo = (params) => {
  const {
    component_iid,
    data,
  } = params;

  return handleExec({
    component_iid,
    component_type: COMPONENT_TYPE.TASK,
    name: `${SERVICE.MISSION}getMission`,
    data: {
      ...data,
      ...handleCheckPlatformId(),
    },
    options: {
      isUseRoleDialog: true,
    },
  });
};

// 处理任务
export const getReward = (params) => {
  const {
    component_iid,
    data,
  } = params;

  return handleExec({
    component_iid,
    component_type: COMPONENT_TYPE.TASK,
    name: `${SERVICE.MISSION}dealSimpleMission`,
    data: {
      ...data,
      ...handleCheckPlatformId(),
    },
    options: {
      isUseRoleDialog: true,
    },
  });
};

// 通过iwan接口处理任务
export const getRewardWithIwan = ({ params }) => ap.get(`${SERVICE.MISSION}dealSimpleMission`, { params });

// 任务上报
export const handleTaskReport = ({ params }) => ap.get('/act/userActionMarked', {
  params,
});

// 获取积分【新】
export const getTeamPoint = (params) => {
  const {
    component_iid,
    data,
  } = params;

  return handleExec({
    component_iid,
    component_type: COMPONENT_TYPE.TEAM,
    data,
    name: `${SERVICE.TEAM}getTeamPoint`,
    options: {
      isUseRoleDialog: true,
    },
  });
};

// 获取积分【老】
export const getPointQuery = (params) => {
  const {
    component_iid,
    data,
  } = params;

  return handleExec({
    component_iid,
    component_type: COMPONENT_TYPE.POINT,
    data,
    name: '/apigateway/point/query',
    options: {
      isUseRoleDialog: true,
    },
  });
};

// 获取助力详情
export const getBoostDetail = (params) => {
  const {
    component_iid,
    data,
  } = params;

  return handleExec({
    component_iid,
    component_type: COMPONENT_TYPE.ASSISTANCE,
    data,
    name: `${SERVICE.BOOST}getBoostDetail`,
    options: {
      isUseRoleDialog: true,
    },
  });
};

// 助力
export const handleDoBoost = (params) => {
  const {
    component_iid,
    data,
  } = params;

  return handleExec({
    component_iid,
    component_type: COMPONENT_TYPE.ASSISTANCE,
    name: `${SERVICE.BOOST}doBoost`,
    data,
    options: {
      isUseRoleDialog: true,
    },
  });
};

// 获取分享口令
export const getShareCmd = async ({ params }) => {
  const defaultParams = {
    name: 'spp_magic_activity_kouling',
    cmd: '1',
    otype: 'xjson',
  };
  const opts = params;
  opts.pageid = opts.pageid || '61';

  const res = await ap.get('https://vip.video.qq.com/fcgi-bin/comm_cgi', {
    params: { ...defaultParams, ...opts },
  }) || {};
  const { ret, cmdTextList } = res;
  if (!ret) {
    if (cmdTextList) {
      const cmdTextListParse = JSON.parse(cmdTextList);
      const [result] = cmdTextListParse;
      const { text } = result;
      if (Array.isArray(text) && text.length > 0) {
        cmdTextListParse[0].text = text[0];
        res.cmdTextList = JSON.stringify(cmdTextListParse);
      }
    }

    return {
      data: res,
      ret: 0,
    };
  }

  return {
    data: {},
    ret: 0,
  };
};

// 获取环境信息
const getEnvOs = () => {
  const nav = navigator.userAgent.toLowerCase();
  const isIphone = nav.indexOf('iphone') > -1;
  const isAndroid = nav.indexOf('android') > -1;
  const env = isIphone ? 'ios' : isAndroid ? 'android' : 'others';

  return env;
};

// 不同平台的platformId区分
const handleCheckPlatformId = () => {
  const { host } = window.location;
  const os = getEnvOs();
  const platformid = getPlatformId();

  const platformIdList = [
    {
      platformId: 'd',
      domain: 'weishi.qq.com',
      system: 'android',
    },
    {
      platformId: 'e',
      domain: 'weishi.qq.com',
      system: 'ios',
    },
    {
      platformId: 'f',
      domain: 'sports.qq.com',
      system: 'android',
    },
    {
      platformId: 'g',
      domain: 'sports.qq.com',
      system: 'ios',
    },
  ];
  const platform = platformIdList.find(platformId => (host.indexOf(platformId.domain) > -1) && (platformId.system === os));
  if (!platform) {
    return {
      platformId: platformid,
      platformid,
    };
  }
  const { platformId } = platform;

  return {
    platformId,
    platformid: platformId,
  };
};

// 中台执行函数
export const handleExec = async (params) => {
  const {
    component_iid,
    component_type,
    name,
    data,
    options = {},
  } = params;
  const { method = 'get' } = options;
  const { exec, toGetParams } = globalThis.$utils;
  data.srcReq = 'act_platform';
  const qualifierParams = await handleGetQualifierParams(params);

  try {
    const res = await exec({
      component_iid,
      component_type,
    }, {
      name,
      data: method !== 'get' ? data : toGetParams(data),
    }, qualifierParams);
    const { data: result, qualifierResult } = res;
    const { expressResult, udfExprResults } = qualifierResult;
    if (!expressResult) {
      const text = qualifierTips(udfExprResults);
      tips({ text });
      throw new Error('条件不通过~');
    } else {
      return result;
    }
  } catch (e) {
    console.log('我是错误');
    console.log(e);
  }
};

// 条件没通过文案
function qualifierTips(results) {
  const tips = results.reduce((acc, cur) => {
    const { desc, expect: { count_val: { count } }, fixedOperator } = cur;

    return [...acc, `${desc}${fixedOperator}${count}`];
  }, []);

  return `${tips.join(',')}条件不满足，请稍后重试~`;
}

// 参数转换
function findParams(data, paramName) {
  if (data[paramName]) {
    return data[paramName];
  }
  if (paramMap[paramName]) {
    const alias = paramMap[paramName];

    return data[alias];
  }
}

// 获取游戏条件
async function handleGetQualifierParams(params) {
  const {
    component_iid,
    component_type,
    name,
    data,
    options = {},
  } = params;

  // 是否需要交互，去获取区服信息
  const { isUseRoleDialog } = options;
  // 中台提供条件参数列表
  const qualifiers = globalThis.$utils.getQualitifiersByComId({ component_iid, component_type }, name);

  // 获取条件最终参数的数值 qualifierParams
  const gameIds = getGameIds(qualifiers);
  const gameId = gameIds.find(gameId => gameId !== '0');
  let qualifierParams = {};
  if (gameId && isUseRoleDialog) {
    qualifierParams = await getRoleInfo(gameId);
  } else {
    qualifierParams = data;
  }

  return qualifiers.map((paramInfo) => {
    const { param_name, default_value: defaultValue, biz_name, udf_name  } = paramInfo;

    return {
      biz_name,
      udf_name,
      param_name,
      value: findParams(qualifierParams, param_name) || defaultValue, // 这里设置参数名对应的value
    };
  });
}

// 通过条件获取gameId
function getGameIds(qualifiers) {
  return Array.from(new Set(qualifiers.map(qua => qua.biz_name.split('_')[1] || '0')));
}

// 通过gameId获取区服角色
async function getRoleInfo(gameId) {
  return new Promise((resolve) => {
    const dialog = roleSelectDialog({ gameId });
    dialog.on('confirm', ({ selectRole, selectZone }) => {
      const params = {
        sPlat: selectZone.systemId,
        sArea: selectZone.channelId,
        serverId: selectRole.serverId,
        sRoleId: selectRole.roleId,
      };

      resolve(params);
      dialog.close();
    });
  });
}

